/* Sync "Add to cart" button price with the main product price */
(() => {
    const observers = new Map();

    const parseCents = (text) => {
        const match = text.match(/\d[\d.,\s  ]*/);
        if (!match) return null;

        const raw = match[0].replace(/[\s  ]/g, '');
        const sep = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
        let whole = raw;
        let decimals = '';

        if (sep !== -1 && raw.length - sep - 1 <= 2) {
            whole = raw.slice(0, sep);
            decimals = raw.slice(sep + 1);
        }

        whole = whole.replace(/[.,]/g, '');
        return parseInt(whole + decimals.padEnd(2, '0'), 10);
    };

    const syncPrice = (suffix) => {
        const id = CSS.escape(suffix);
        const mainPrice = document.querySelector(`#Price-${id} .price__regular`);
        const buyPrice = document.querySelector(`#BuyButtonPrice-${id} product-buy-price`);
        if (!mainPrice || !buyPrice) return;

        const text = mainPrice.textContent.trim();
        if (!text || buyPrice.textContent.trim() === text) return;

        const cents = parseCents(text);
        if (cents !== null && !isNaN(cents)) buyPrice.setAttribute('data-price', cents);
        buyPrice.textContent = text;
    };

    const init = () => {
        document.querySelectorAll('[id^="BuyButtonPrice-"]').forEach((buyWrapper) => {
            const suffix = buyWrapper.id.replace('BuyButtonPrice-', '');
            const priceContainer = document.getElementById(`Price-${suffix}`);
            if (!priceContainer) return;

            observers.get(suffix)?.disconnect();

            const observer = new MutationObserver(() => syncPrice(suffix));
            observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
            observers.set(suffix, observer);

            syncPrice(suffix);
        });
    };

    const syncAll = () => {
        observers.forEach((_, suffix) => syncPrice(suffix));
    };

    document.addEventListener('variant:change', () => {
        syncAll();
        setTimeout(syncAll, 150);
        setTimeout(syncAll, 500);
    });

    document.addEventListener('shopify:section:load', init);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/* Remove linked add-on products from the cart together with the main product */
(() => {
    const ADDON_HANDLE_PREFIX = 'option-set-';
    const CHANGE_URL_REGEX = /\/cart\/change(\.js)?(\?|$)/;
    const nativeFetch = window.fetch.bind(window);

    const normalize = (value) => String(value ?? '').toLowerCase().replace(/[^a-z0-9]+/g, '');

    const getUpdates = (cart, lineId) => {
        const main = cart.items.find((item) => item.key === lineId || String(item.variant_id) === String(lineId));
        if (!main || main.handle.startsWith(ADDON_HANDLE_PREFIX)) return null;

        const group = main.properties?._gpo_product_group;
        const selected = Object.entries(main.properties || {})
            .filter(([name]) => !name.startsWith('_'))
            .map(([name, value]) => [normalize(name), normalize(value)]);

        const updates = { [main.key]: 0 };

        cart.items
            .filter((item) => item.handle.startsWith(ADDON_HANDLE_PREFIX))
            .filter((addon) => group
                ? addon.properties?._gpo_parent_product_group === group
                : selected.some(([name, value]) => name === normalize(addon.product_title) && value === normalize(addon.variant_title)))
            .forEach((addon) => {
                updates[addon.key] = Math.max(0, addon.quantity - main.quantity);
            });

        return Object.keys(updates).length > 1 ? updates : null;
    };

    window.fetch = async function (input, init) {
        const url = typeof input === 'string' ? input : input?.url || '';

        if (!CHANGE_URL_REGEX.test(url) || typeof init?.body !== 'string') {
            return nativeFetch(input, init);
        }

        try {
            const body = JSON.parse(init.body);
            if (Number(body.quantity) !== 0 || !body.id) return nativeFetch(input, init);

            const cart = await nativeFetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
            const updates = getUpdates(cart, body.id);
            if (!updates) return nativeFetch(input, init);

            const { id, line, quantity, ...rest } = body;
            return nativeFetch(url.replace(CHANGE_URL_REGEX, '/cart/update.js$2'), {
                ...init,
                body: JSON.stringify({ ...rest, updates })
            });
        } catch (error) {
            console.error(error);
            return nativeFetch(input, init);
        }
    };
})();

/* Product page: keep the cart drawer flow when Globo add-ons are added to cart */
(() => {
    const SUBMIT_SELECTOR = '.product-form__submit';
    const ADD_URL_REGEX = /\/cart\/add(\.js)?(\?|$)/;
    const nativeFetch = window.fetch.bind(window);
    let activeAt = 0;
    let themeSubmittedAt = 0;
    let drawerTimer;

    const isActive = () => Date.now() - activeAt < 10000;

    const openDrawer = () => {
        clearTimeout(drawerTimer);
        drawerTimer = setTimeout(async () => {
            try {
                const cart = await (await nativeFetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'))).json();
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart });
            } catch (error) {
                console.error(error);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        }, 300);
    };

    document.addEventListener('click', (event) => {
        if (event.target.closest?.(SUBMIT_SELECTOR)) activeAt = Date.now();
    }, true);

    document.addEventListener('submit', (event) => {
        if (event.target.matches?.('form[is="product-form"]')) themeSubmittedAt = Date.now();
    }, true);

    window.fetch = async function (input, init) {
        const url = typeof input === 'string' ? input : input?.url || '';
        const isAdd = ADD_URL_REGEX.test(url);
        if (isAdd) activeAt = Date.now();

        const response = await nativeFetch(input, init);

        if (isAdd && response.ok && Date.now() - themeSubmittedAt > 10000) openDrawer();

        return response;
    };

    window.navigation?.addEventListener('navigate', (event) => {
        const url = new URL(event.destination.url);
        const isCartPage = url.origin === window.location.origin && /\/cart$/.test(url.pathname.replace(/\/$/, ''));
        if (!isCartPage || !isActive() || !event.cancelable || event.userInitiated) return;

        event.preventDefault();
        openDrawer();
    });
})();

/* Globo option prices: "(+ €21,00)" -> "+€21,00" */
(() => {
    const format = (root) => {
        root.querySelectorAll('.gpo-swatches .addOn').forEach((element) => {
            const text = element.textContent.trim();
            const formatted = text.replace(/^\(\s*(.*?)\s*\)$/, '$1').replace(/^\+\s+/, '+');
            if (formatted !== text) element.textContent = formatted;
        });
    };

    const init = () => {
        const app = document.querySelector('.gpo-app');
        if (!app) return;

        format(app);
        new MutationObserver(() => format(app)).observe(app, { childList: true, subtree: true, characterData: true });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', init);
})();

/* Product color options: scroll the current color into view */
(() => {
    const centerCurrent = () => {
        document.querySelectorAll('.product-colors__list').forEach((list) => {
            const current = list.querySelector('[aria-current="true"]');
            if (!current) return;

            const offset = current.getBoundingClientRect().left - list.getBoundingClientRect().left;
            list.scrollLeft += offset - (list.clientWidth - current.offsetWidth) / 2;
        });
    };

    centerCurrent();
    document.addEventListener('page:loaded', centerCurrent);
})();

/* Suronics filter */
(function () {
    var cache = new Map();

    function loadFilters(baseUrl, pairs) {
        var url = new URL(baseUrl, window.location.origin);
        pairs.forEach(function (pair) {
            url.searchParams.set(pair[0], pair[1]);
        });
        url.searchParams.set('section_id', 'suronics-filter-data');
        var key = url.toString();
        if (!cache.has(key)) {
            cache.set(key, fetch(key, { credentials: 'same-origin' })
                .then(function (response) { return response.text(); })
                .then(function (html) {
                    var doc = new DOMParser().parseFromString(html, 'text/html');
                    var script = doc.querySelector('script[type="application/json"]');
                    return script ? JSON.parse(script.textContent) : {};
                })
                .catch(function () {
                    cache.delete(key);
                    return {};
                }));
        }
        return cache.get(key);
    }

    function init(root) {
        if (!root || root.dataset.ready) return;
        root.dataset.ready = 'true';

        var form = root.querySelector('form');
        var go = root.querySelector('[data-go]');
        var resultsUrl = root.dataset.resultsUrl;
        var params = {
            make: root.dataset.makeParam,
            model: root.dataset.modelParam
        };
        var selects = {};
        var order = [];
        ['make', 'model'].forEach(function (name) {
            var select = root.querySelector('[data-field="' + name + '"]');
            if (select && params[name]) {
                selects[name] = select;
                order.push(name);
            }
        });
        if (!order.length) return;

        var token = 0;
        var current = new URLSearchParams(window.location.search);

        function selectedPairs(upTo) {
            var pairs = [];
            for (var i = 0; i < upTo; i++) {
                var value = selects[order[i]].value;
                if (value) pairs.push([params[order[i]], value]);
            }
            return pairs;
        }

        function updateGo() {
            var ready = selects.make.value && selects.model.value;
            go.disabled = !ready;
        }

        function reset(name) {
            var select = selects[name];
            var placeholder = select.options[0];
            select.innerHTML = '';
            select.appendChild(placeholder);
            select.value = '';
            select.disabled = true;
            if (select.onChange) select.onChange();
        }

        function fill(index, preselect) {
            var name = order[index];
            var select = selects[name];
            var requestId = ++token;
            for (var i = index; i < order.length; i++) reset(order[i]);
            updateGo();

            return loadFilters(resultsUrl, selectedPairs(index)).then(function (data) {
                if (requestId !== token) return;
                var values = (data[params[name]] || []).filter(function (item) { return item.count > 0; });
                values.sort(function (a, b) {
                    return a.label.localeCompare(b.label, undefined, { numeric: true });
                });
                values.forEach(function (item) {
                    var option = document.createElement('option');
                    option.value = item.value;
                    option.textContent = item.label;
                    select.appendChild(option);
                });
                select.disabled = !values.length;
                if (preselect && preselect[name]) select.value = preselect[name];
                if (select.onChange) select.onChange();
                updateGo();
            });
        }

        function bind(index) {
            selects[order[index]].addEventListener('change', function () {
                if (index + 1 < order.length) {
                    if (this.value) fill(index + 1);
                    else for (var i = index + 1; i < order.length; i++) reset(order[i]);
                }
                updateGo();
            });
        }

        order.forEach(function (name, index) { bind(index); });

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (go.disabled) return;
            var url = new URL(resultsUrl, window.location.origin);
            selectedPairs(order.length).forEach(function (pair) {
                url.searchParams.append(pair[0], pair[1]);
            });
            window.location.href = url.toString();
        });

        // Preselect from the current URL (e.g. on the results page)
        var preselect = {};
        order.forEach(function (name) {
            var value = current.get(params[name]);
            if (value) preselect[name] = value;
        });

        function chain(index) {
            if (index >= order.length) return;
            fill(index, preselect).then(function () {
                if (preselect[order[index]] && selects[order[index]].value) chain(index + 1);
            });
        }
        chain(0);
    }

    function initAll() {
        document.querySelectorAll('[data-suronics-filter]').forEach(init);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState !== 'loading') initAll();
})();